import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar.component';
import { PageTitleComponent } from '../header/page-title/page-title.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ToolbarComponent,PageTitleComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [ToolbarComponent],
})

export class ToolbarModule { }
